import React from 'react';

import { FilteredProductSearch } from 'src/explore/compositions/FilteredProductSearch';

// Order is important
const AVAILABLE_SORTING = [ 'recommended', 'best_sellers', 'price_low', 'price_high' ];

const Collection = ({ clickRef, collectionId, merchant: { logoImageUrl, name }}) => (
  <div className="container-xl spec__collection">
    <FilteredProductSearch
      availableSorting={AVAILABLE_SORTING}
      clickRef={clickRef}
      conditions={{ collection_ids: collectionId }}
      eventProperties={
        logoImageUrl
          ? {
              gridViewed: {
                whitelabel_merchant: {
                  logo_url: logoImageUrl,
                  name,
                },
              },
            }
          : undefined
      }
      hideMerchant
    />
  </div>
);

export default Collection;
